import Lottie from "lottie-react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { greenColor, whiteColor } from "../../utils/colors";
import geoLocationAnime from "../../assets/lottie/GeoLocationAnime.json";
import Loader from "../../components/loader/Loader";
import { SaveUserAddressObject } from "../../redux/user/userSlice";
import useCurrentGeoLocation from "../../hooks/useCurrentGeoLocation";
import { getAddressFromGeoLocation } from "../../utils/locationUtils";
import { useNotification } from "../../components/shared/NotificationProvider";

const GetLocationModal = ({ openModal, setOpenModal }) => {
  const { isLoading, geoLocation, error } = useCurrentGeoLocation();
  const dispatch = useDispatch();
  const notify = useNotification();

  const handleClose = () => {
    setOpenModal(false);
    notify.error("Please allow location access as it helps us to give better services. Refresh the page to share location.");
  };

  const handleModalSubmit = async () => {
    if (isLoading) {
      notify.info("Fetching your location. Please wait.");
      return;
    }

    if (error) {
      setOpenModal(false);
      notify.error(error);
      return;
    }

    if (geoLocation.latitude && geoLocation.longitude) {
      try {
        const coordinates = [geoLocation.latitude, geoLocation.longitude];
        const currentLocation = await getAddressFromGeoLocation({ latitude: geoLocation.latitude, longitude: geoLocation.longitude });
        const response = await dispatch(SaveUserAddressObject({ currentLocation, coordinates }));
        setOpenModal(false);
        notify[response.payload.status === "success" ? "success" : "error"](response.payload.message);
      } catch {
        setOpenModal(false);
        notify.error("Some error occurred. Please try again.");
      }
    } else {
      notify.error("Unable to fetch location. Please try again.");
    }
  };

  return (
    <div>
      {isLoading && <Loader />}
      <Dialog
        open={openModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Share your location</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              height: '150px',
              width: '170px%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Lottie
              animationData={geoLocationAnime}
              style={{ width: '100%', height: '100%' }}
              loop
              autoplay
            />
          </Box>
          <DialogContentText id="alert-dialog-description">
            This helps us to show you better results
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={handleClose}
            color="primary"
            sx={{
              background: whiteColor,
              color: greenColor,
              borderColor: greenColor,
              "&:hover": {
                backgroundColor: greenColor,
                color: whiteColor
              },
            }}
          >
            Decline
          </Button>
          <Button
            variant="contained"
            onClick={handleModalSubmit}
            sx={{
              background: greenColor,
              "&:hover": {
                backgroundColor: whiteColor,
                color: greenColor
              },
            }}
          >
            Share
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GetLocationModal;
